export default __webpack_public_path__ + "static/media/GearTriumph1.8a98115b.jpg";